import Axios from "../utils/axios";



export const loadPosSalesReport = async (date) => {
  try {
    let url = `reports/pos_sales`;
    if  (date !== null) url += `?date=${JSON.stringify(date)}`;
    const response = await Axios.get(url);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};